import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';

const loadWfCmsCollectionPage = () => import( './components/webflow/wf-cms-collection-page/wf-cms-collection-page.component' ).then( m => m.WfCmsCollectionPageComponent );

const loadWfContactPage = () => import( './components/webflow/wf-contact-page/wf-contact-page.component' ).then( m => m.WfContactPageComponent );

const loadTermsOfService = () => import( './components/webflow/terms-of-service/terms-of-service.component' ).then( m => m.TermsOfServiceComponent );

const loadPrivacyPolicy = () => import( './components/webflow/privacy-policy/privacy-policy.component' ).then( m => m.PrivacyPolicyComponent );

/** Rutas históricas / bookmarks → URLs alineadas con el export Webflow. */
const LEGAL_LEGACY_REDIRECTS: Routes = [
  { path: 'terms', pathMatch: 'full', redirectTo: '/terms-of-service' },
  { path: 'privacy', pathMatch: 'full', redirectTo: '/privacy-policy' }
];

const WF_SOLUTION_ROUTES: Routes = [
  { path: 'ai-revenue', loadComponent: loadWfCmsCollectionPage, data: { wfHtmlPath: 'solutions/ai-revenue.html' } },
  { path: 'flows', loadComponent: loadWfCmsCollectionPage, data: { wfHtmlPath: 'solutions/flows.html' } },
  { path: 'ai-creative-studio', loadComponent: loadWfCmsCollectionPage, data: { wfHtmlPath: 'solutions/ai-creative-studio.html' } },
  { path: 'omnichannel-news', loadComponent: loadWfCmsCollectionPage, data: { wfHtmlPath: 'solutions/omnichannel-news.html' } }
];

const WF_TECHNOLOGY_ROUTES: Routes = [
  { path: 'global-infrastructure', loadComponent: loadWfCmsCollectionPage, data: { wfHtmlPath: 'technology/global-infrastructure.html' } },
  { path: 'icortex-smart-routing', loadComponent: loadWfCmsCollectionPage, data: { wfHtmlPath: 'technology/icortex-smart-routing.html' } },
  { path: 'lifestyle-engine', loadComponent: loadWfCmsCollectionPage, data: { wfHtmlPath: 'technology/lifestyle-engine.html' } },
  { path: 'predictive-cortex', loadComponent: loadWfCmsCollectionPage, data: { wfHtmlPath: 'technology/predictive-cortex.html' } }
];

const APP_ROUTES: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'contact', loadComponent: loadWfContactPage },
  { path: 'pricing', loadComponent: loadWfCmsCollectionPage, data: { wfHtmlPath: 'pricing.html' } },
  { path: 'privacy-policy', loadComponent: loadPrivacyPolicy },
  { path: 'terms-of-service', loadComponent: loadTermsOfService },
  { path: 'terms-and-condition', pathMatch: 'full', redirectTo: '/terms-of-service' },
  { path: 'solutions', children: WF_SOLUTION_ROUTES },
  { path: 'technology', children: WF_TECHNOLOGY_ROUTES },
  {
    path: 'signup',
    loadChildren: () => import( './components/signup/signup.module' ).then( m => m.SignupModule )
  },
  {
    path: 'loginAuth',
    loadChildren: () => import( './components/shared/login-auth/login-auth.module' ).then( m => m.LoginAuthModule )
  },
  { path: 'legal', children: LEGAL_LEGACY_REDIRECTS },
  { path: '**', pathMatch: 'full', redirectTo: 'home' }
];

export const APP_ROUTING = RouterModule.forRoot( APP_ROUTES, {
  scrollPositionRestoration: 'top'
} );
